import styled from 'styled-components/native';
import Colors from '../colors';
const TYPES = ['default', 'discount'];
const StyledContainer = styled.View`
  padding: 16px;
  border-radius: 4px;
  background-color: ${Colors.lightGray100};
`;
export { TYPES, StyledContainer };
//# sourceMappingURL=shared.js.map